import React from 'react';
import { ContentTemplate, TitleHeader } from 'web-library';
import { useTranslation } from 'react-i18next';
import PaymentLinkError from '../../components/PaymentLinkError';

const InvalidUniqueLink = () => {
  const { t } = useTranslation();
  return (
    <>
      <TitleHeader title={t('components->>PaymentLinkError.Link is invalid!')} />

      <ContentTemplate>
        <PaymentLinkError
          typographyMessage={t('components->>PaymentLinkError.Sorry, this link is invalid.')}
          buttonMessage={t('components->>PaymentLinkError.Back to Home')}
        />
      </ContentTemplate>
    </>
  );
};

export default InvalidUniqueLink;
